module.exports = __webpack_public_path__ + "img/bystyle@2x.8a8cdb2.webp";